// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import RouteBuilder from '@Services/RouteBuilder';
import { CardContentProps } from '../CardContentType';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import { useLocalMessage } from '@Helpers/locale';
import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import { ICONS } from '@Constants/iconsApp';
import { OperationType } from 'thehive-sdk';

export const PageContent = ({ data, base }: CardContentProps): ReactElement => {
    const local = useLocalMessage();
    const { rootId, action, details, context } = base;
    const { case: dataCase, alert: dataAlert } = data || {};

    const parent = dataAlert || dataCase || context;

    const rootPath = RouteBuilder.compute('cases.pages', { caseId: rootId });

    const customDetails =
        action === 'create'
            ? {
                  title: details.title,
              }
            : details;

    const libTitle: Record<OperationType, string> = {
        create: local('stream.card.page.create'),
        update: local('stream.card.page.update'),
        merge: '',
        delete: local('stream.card.page.delete'),
    };

    return (
        <StreamCard
            icon={<ICONS.SnippetsOutlined />}
            title={rootPath ? libTitle[action] : libTitle.delete}
            path={rootPath}
            base={base}
            parent={parent}
        >
            {Object.entries(customDetails).map(([key, value]) => (
                <PropRender key={rootId + key} prop={key} value={value} type="page" />
            ))}
        </StreamCard>
    );
};
